import { useFormikContext } from 'formik';
import { Button } from '../ui/Button';

interface SubmitButtonProps {
  title: string;
  theme?: 'primary' | 'secondary' | 'outline' | 'gray';
}

export function SubmitButton({ title, theme = 'primary' }: SubmitButtonProps) {
  const { handleSubmit, isSubmitting } = useFormikContext();

  return (
    <Button
      type="submit"
      theme={theme}
      disabled={isSubmitting}
      onClick={() => handleSubmit()}
    >
      {title}
    </Button>
  );
}

export default SubmitButton;
